import { render, staticRenderFns } from "./Calls.vue?vue&type=template&id=e308c55a&scoped=true"
import script from "./Calls.vue?vue&type=script&lang=js"
export * from "./Calls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e308c55a",
  null
  
)

export default component.exports